// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import md5 from 'js-md5'

import Api from './api'
import Vant from 'vant';
import Icon from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css'
import "@/assets/css/style.css"
import Toast from 'vant';
import {Lazyload} from 'vant';
import { Cell, CellGroup} from 'vant';
import { Checkbox, CheckboxGroup,Notify } from 'vant';
import "@/assets/icon/iconfont.css"
import "@/assets/icon/iconfont.js"
import Clipboard from 'clipboard';

Vue.config.productionTip = false
Vue.prototype.$api = Api
Vue.prototype.$md5 = md5

Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(Icon);
Vue.use(Toast)
Vue.use(Lazyload)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Notify)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js